// ProtectedRoute.tsx
import React, { useContext } from "react";
import { Navigate } from "react-router";
import AuthContext from "../context/AuthContext";

interface ProtectedRouteProps {
  children: JSX.Element;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isLoading } = useContext(AuthContext);

  // While checking for an existing token, you can return a loader or null
  if (isLoading) {
    return <div>Loading...</div>; // Or a spinner component
  }

  // If no user exists, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}